/* eslint-disable max-len */
import * as React from "react";

import { theme } from "@byko/lib-styles";

import type { BykoReactIconComponentType } from "../../icon-types";

export const AttentionIcons: BykoReactIconComponentType = ({ size = 24, iconColor = theme.palette.blue.dark }) => {
  return (
    <svg fill="none" height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1432_7120)">
        <path
          d="M1.24302 18.953L10.152 2.11098C10.33 1.77464 10.5963 1.49318 10.9222 1.29687C11.2482 1.10056 11.6215 0.996826 12.002 0.996826C12.3825 0.996826 12.7559 1.10056 13.0818 1.29687C13.4078 1.49318 13.6741 1.77464 13.852 2.11098L22.761 18.953C22.9282 19.2708 23.0103 19.6265 22.9991 19.9855C22.988 20.3445 22.8841 20.6944 22.6975 21.0013C22.5109 21.3081 22.2479 21.5614 21.9343 21.7364C21.6207 21.9114 21.2672 22.0022 20.908 22H3.09202C2.73323 22.0015 2.38014 21.9102 2.06709 21.7349C1.75404 21.5596 1.49169 21.3063 1.30555 20.9995C1.11942 20.6928 1.01583 20.3431 1.00488 19.9845C0.993918 19.6259 1.07596 19.2705 1.24302 18.953V18.953Z"
          stroke={iconColor}
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path d="M12 8V14" stroke={iconColor} strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" />
        <path
          d="M12 19C12.8284 19 13.5 18.3284 13.5 17.5C13.5 16.6716 12.8284 16 12 16C11.1716 16 10.5 16.6716 10.5 17.5C10.5 18.3284 11.1716 19 12 19Z"
          fill={iconColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1432_7120">
          <rect fill="white" height={size} width={size} />
        </clipPath>
      </defs>
    </svg>
  );
};
